import React, { useState, useEffect } from 'react';

// A small list of hosts that commonly cause CORS/DNS/404 issues in this project
const HOST_BLOCKLIST = [
  'medlatec.vn',
  'awakenyourpower.vn',
  'psychology.vn',
  'umc.edu.vn'
];

const DEFAULT_PROFESSIONAL = 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=300&h=300&fit=crop&crop=face';

function hostnameFromUrl(u) {
  try {
    return new URL(u).hostname.replace(/^www\./, '');
  } catch (e) {
    return null;
  }
}

export default function SafeImage({ src, alt = '', className = '', style = {}, nameForUiAvatar = '', fallbackSrc, onLoad, onError }) {
  const [currentSrc, setCurrentSrc] = useState(null);
  const [triedFallback, setTriedFallback] = useState(false);

  useEffect(() => {
    setTriedFallback(false);
    if (!src) {
      setCurrentSrc(null);
      return;
    }

    const host = hostnameFromUrl(src);
    if (host && HOST_BLOCKLIST.includes(host)) {
      // immediately use fallback to avoid slow DNS/blocked hosts
      setCurrentSrc(fallbackSrc || `https://ui-avatars.com/api/?name=${encodeURIComponent(nameForUiAvatar || alt || 'Expert')}&background=3b82f6&color=fff&size=128`);
    } else {
      setCurrentSrc(src);
    }
  }, [src, fallbackSrc, alt, nameForUiAvatar]);

  const handleError = (e) => {
    if (onError) onError(e);
    if (triedFallback) return;
    setTriedFallback(true);
    if (fallbackSrc) {
      setCurrentSrc(fallbackSrc);
      return;
    }
    // try ui-avatars
    setCurrentSrc(`https://ui-avatars.com/api/?name=${encodeURIComponent(nameForUiAvatar || alt || 'Expert')}&background=3b82f6&color=fff&size=128`);
  };

  if (!currentSrc) {
    // render a placeholder box (avoids broken requests when src missing)
    return (
      <div className={`safe-image-placeholder ${className}`} style={{ display: 'inline-block', background: '#eee', width: 80, height: 80, borderRadius: 8, ...style }} aria-label={alt} />
    );
  }

  return (
    // eslint-disable-next-line jsx-a11y/img-redundant-alt
    <img src={currentSrc} alt={alt || 'avatar'} className={className} style={style} onError={handleError} onLoad={onLoad} />
  );
}
